import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, ElementRef, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { newWorkerStages, WorkforceActions } from 'src/app/store/workforce.era';
import { take } from 'rxjs/operators';
import { WFWorker, WorkforceGroup } from 'src/app/store/events.era';
import { ManageWorkersComponent } from '../manage-workers/manage-workers.component';
import { SearchBarComponent } from '../search-bar';
import { sleepForMS, filterByKeywordAndProps } from 'src/app/helpers/helpers';
import { OMEGA_GROUP_NAME } from 'globals/store/tasks.data';
import { Wrapper } from '../wrapper.component';
import { jsonCopyObject, sortByProp } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';
import { IconComponent } from '../icon/icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-people-picker',
    templateUrl: './people-picker.html',
    styleUrls: ['./people-picker.component.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, ManageWorkersComponent, SearchBarComponent, PhotoComponent, IconComponent],
})
export class PeoplePickerComponent extends Wrapper<PeoplePickerComponent> implements OnInit, AfterViewInit, OnDestroy {

  readonly panelHeight = 300;
  newWorker: WFWorker
  newWorkerStatus
  newWorkerStages = newWorkerStages;
  isInviting;
  possible_groups: WorkforceGroup[] = [];
  possible_people: WFWorker[]  = [];
  mandatoryEntry:{people:{},groups:{}};
  title = 'Workforce';
  filter_word = '';
  include_all_option_selected = false;
  worker;
  need_to_add = false;
  allGroupName = OMEGA_GROUP_NAME // 'Everyone in Workforce';
  selected:{people:{},groups:{}} = {people:{},groups:{}};
  disableEveryoneInWorkforceOption
  @ViewChild('manageWorkers', { static: true }) manageWorkers: ManageWorkersComponent;
  @ViewChild('searchEl') searchEl:ElementRef;
  @ViewChild(SearchBarComponent, { static: true }) searchBar: SearchBarComponent

  constructor(public dialogRef:MatDialogRef<PeoplePickerComponent>, @Inject(MAT_DIALOG_DATA) public data: PeoplePickerData) {

    super()
    this.sortPeople()
    this.initializeData(this.data)

    this.subProp(this.store.select('workforce','newWorker'), 'newWorker')
    this.subCallback(this.store.select('workforce','newWorkerStatus'), newWorkerStatus => {
      this.newWorkerStatus = newWorkerStatus
      if (newWorkerStatus) {
        this.isInviting = [newWorkerStages.send_invite as string, newWorkerStages.invite_existing].includes(newWorkerStatus)
      }
    })
  }

  sortPeople() {
    const people = jsonCopyObject(this.data.people)
    const groups = jsonCopyObject(this.data.groups)
    if (people) {
      people.forEach(p => p.displayName = `${p.firstName || ''}${p.firstName ? ' ' : ''}${p.lastName || ''}`)
      people.sort(sortByProp('displayName'))
    }
    if (groups) groups.sort(sortByProp('realName'))
  }

  initializeData(data) {
      if (data.title) this.title = data.title
      if(data.groups) {
        this.possible_groups = [...data.groups]
      }
      this.possible_people = [...data.people];
      this.selected = data.selected;
      if(data.allGroupName) this.allGroupName = data.allGroupName;
      this.mandatoryEntry = data.mandatoryEntry || {people:{},groups:{}};
      if(data.disableEveryoneInWorkforceOption || !data.groups) this.disableEveryoneInWorkforceOption = true;
      if(this.selected.groups && this.selected.groups['--all--']){
        this.include_all_option_selected = true;
      }
      if(this.possible_people.length === 0 && this.possible_groups.length === 0 && !this.data.disallowNewWorker){
        this.need_to_add = true
      }
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    if (document.body.clientHeight - this.data.y < 400) {
      this.data.y = document.body.clientHeight - 400;
    }
    this.dialogRef.updatePosition({ top: (this.data.y) + 'px', left: (this.data.x) + 'px' });
    this.store.dispatch(WorkforceActions.changeNewWorkerStatus('email_address'))
    

    setTimeout(_=>{
      // this errored in a conflict, so I will need to fix it after // this.searchBar.focus()
      // this.searchEl.nativeElement.focus();
    })
  }

  toggleSelected(type, key){
    // console.log({ type, key, possible_people: this.possible_people, selected: jsonCopyObject(this.selected) })
    // if(this.include_all_option_selected && key !== '--all--') return;
    if (this.data.singleSelection) return this.dialogRef.close({ selected: key })
    if(this.mandatoryEntry[type][key] && this.selected[type][key]) return;
    if(!this.selected[type]) this.selected[type] = {};
    if(!this.data.multi){
      // loop through all and make false
      const selected_keys = Object.keys(this.selected[type])
      for (const selected_key of selected_keys) {
        if (key !== selected_key) {
          this.selected[type][selected_key] = false;
        }
      }
    }
    this.selected[type][key] = !this.selected[type][key];
    // console.log({ selected: jsonCopyObject(this.selected) })
    this.include_all_option_selected = this.selected.groups && this.selected.groups['--all--'];
    this.data.emitter.emit(this.selected)
  }

  async add(and_invite?:boolean) { 

    const workers = this.manageWorkers.getSelectedWorkers()
    let newWorker: WFWorker = await this.take1(this.store.select('workforce','newWorker'))
    // console.log({ workers, newWorker, selected: jsonCopyObject(this.selected) })
    if (workers && workers.length) {
      newWorker = workers[0]
      await this.store.dispatch(WorkforceActions.updateNewWorker(newWorker))
    }

    newWorker.email = newWorker.email.toLocaleLowerCase();
    const selected = newWorker
    this.selected.people[selected.email] = true;
    
    if(and_invite){
      this.workforceService.$events.next({type:'workforce',action:this.workforceService.ADD_WORKFORCE_PROGRESS,data:{}})
      this.store.dispatch(WorkforceActions.changeNewWorkerStatus('send_invite'))
    }else{
      this.reduceSelectedToOneIfNecessary()
      if (workers && workers.length) await sleepForMS(300) // need to wait here for a moment since the newWorker would have been dispatched to the store if they were selected from contacts and workforce.addWorkerToWorkforce depends on that newWorker being present
      this.workforceService.addWorkerToWorkforce();
      if (this.data.singleSelection) return this.dialogRef.close({ selected: newWorker.email })
      this.data.emitter.emit(this.selected)
      this.close();
    }

  }

  onSearchInput(search_value){
    // const search_value = $event.target.value;
    const peopleFilterFunction = filterByKeywordAndProps(search_value, ['firstName', 'lastName'])
    this.possible_people = !this.data.people ? [] : !search_value ? this.data.people : this.data.people.filter(peopleFilterFunction)

    const groupFilterFunction = filterByKeywordAndProps(search_value, ['name'])
    this.possible_groups = !this.data.groups ? [] : !search_value ? this.data.groups : this.data.groups.filter(groupFilterFunction)

    console.log({ people: this.possible_people, groups: this.possible_groups })

    if(this.possible_people.length === 0 && this.possible_groups.length === 0 && !this.data.disallowNewWorker){
      if(search_value) {
        this.need_to_add = true;
        this.swapViews(search_value);
      }
    } else if (search_value === '') {
      this.need_to_add = false;
      this.title = this.data.title || 'Workforce';
      this.store.dispatch(WorkforceActions.updateNewWorker({email:''}))
      this.searchBar.clear()
      // this errored in a conflict, so I will need to fix it after // this.searchBar.clear()
      // this.search_input = ''
      setTimeout(_=>{
        // this errored in a conflict, so I will need to fix it after // this.searchBar.focus()
        this.searchBar.focus()
        // this.searchEl.nativeElement.focus();
      })
    }
  }

  manageWorkerComplete(type){
    if(type === 'reset') {
      this.onSearchInput('')
    }
  }

  swapViews(search_value:string){
    // console.log("SWAP VIEWS CALLED")
    let email = '';
    if(this.need_to_add){
      // add search value to manage worker component
      // focus on manage worker input
      email = typeof search_value === 'string' ? search_value : '';
      this.title = 'Invite to workforce';
      this.manageWorkers.focusOnSwappedSearchValue()
    }else{
      this.title = 'Workforce';
    }
    this.store.dispatch(WorkforceActions.updateNewWorker({email}))
  }

  reduceSelectedToOneIfNecessary() {
    if (this.data.multi === false) { // can only have one selection on a non-multi people picker, in this case send is inviting the new worker, so must delete any previously selected wf member below
      Object.keys(this.selected.people).forEach(email => {
        if (email !== this.newWorker.email) {
          delete this.selected.people[email]
        }
      })
    }
  }

  send(){
    // console.log(jsonCopyObject({ selected: this.selected, newWorker: this.newWorker }))
    this.reduceSelectedToOneIfNecessary()
    this.workforceService.inviteWorker();
    if (this.data.singleSelection) return this.dialogRef.close({ selected: this.newWorker.email })
    this.data.emitter.emit(this.selected)
    this.close();
  }

  close(){
    this.dialogRef.close();
  }

}



export interface PeoplePickerData {
  x: number
  y: number
  multi: boolean
  people: WFWorker[]
  groups: WorkforceGroup[]
  taskResponsiblePerson?: WFWorker
  taskCreator?: WFWorker
  mandatoryEntry?: {
    people: { [email:string]: boolean }
    groups: { [groupName:string]: boolean }
  }
  singleSelection?: boolean
  emitter?: EventEmitter<any>
  selected?: any
  allGroupName?: string
  disableEveryoneInWorkforceOption?: boolean
  title?: string
  disallowNewWorker?: boolean
}

const peopleEmitter: EventEmitter<any> = new EventEmitter;
export const getSingleWorkforcePersonEmail = (event, workforce, matDialog, title="Responsibility", disallowNewWorker = false, currentSelection = null, x = null, y = null): Promise<string> => new Promise((resolve, reject) => {
  const selected = { people: {} }
  if (currentSelection) selected.people[currentSelection] = true
  const data: PeoplePickerData = {
    x: x || event.x - 300,
    y: y || event.y + 30,
    people: workforce,
    groups: null,
    multi: false,
    selected: selected,
    emitter: peopleEmitter,
    title,
    disallowNewWorker
  }
  const dialog = matDialog.open(PeoplePickerComponent, {
    width: '300px',
    autoFocus: false,
    backdropClass: 'clear',
    panelClass: ['popup-center'],
    data,
  })
  const subscription = peopleEmitter.pipe(take(1)).subscribe(selected => {
    if (subscription.closed) return
    
    const people = Object.entries(selected.people)
    
    // Either return the only person in the list (selected or not) or the first selected 
    const person = people.length === 1 ? people[0][0] : people.filter(([_, selected]) => selected === true)[0][0] 
    // console.log({ person })
    dialog.close();
    subscription.unsubscribe()
    return resolve(person)
  })
  dialog.afterClosed().pipe(take(1)).subscribe(result => {
    setTimeout(() => {
      if (!subscription.closed) {
        subscription.unsubscribe()
        resolve(null)
      }
    }, 100)
  });

})